import axios from 'api/axios'
import { useEffect, useState } from 'react'
/**
 * @module FetchHooks
 * @module DatosTrabajador
 */

/**
 * Hook to fetch the worker data
 * @param {UserToHandle} [user] - The user to make the request
 * @return {import('common/types/connections_types').UseFetchHookResponse<ProfessionalDataDto>}
 */
const useFetchProfessionalData = (user = null) => {
  const [response, setResponse] = useState(/**@type {ProfessionalDataDto}*/ null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const fetchData = () => {
    setLoading(true)
    setError(null)
    axios
      .get(`/datosprofesionales/?user=${user ?? ''}`)
      .then((response) => setResponse(response.data))
      .catch((error) => setError(error))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchData()
  }, [user])

  return { response, error, loading }
}

export default useFetchProfessionalData
